export const slotGamePlayTextContent = {
  backBtnText: <span className="text">Back to Games</span>,
  fullscreenBtnText: <span className="text">Full Screen</span>,
  imgSrcGame: "/assets/stock-img/game_info_img.webp",
};
